import { render } from "./TextArea.vue?vue&type=template&id=a4957fda&scoped=true&ts=true"
import script from "./TextArea.vue?vue&type=script&lang=ts"
export * from "./TextArea.vue?vue&type=script&lang=ts"

import "./TextArea.vue?vue&type=style&index=0&id=a4957fda&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4957fda"]])

export default __exports__